// ** Initial State
const initialState = {
    allData: [],
    data: [],
    total: 1,
    params: {},
    selectedUser: null
  }
  
  const usersConductores = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_ALL_DATA_CONDUCTORES':
        return { ...state, allData: action.data }
      case 'GET_DATA_CONDUCTORES':
        return {
          ...state,
          data: action.data,
          total: action.totalPages,
          params: action.params
        }
      case 'GET_USER_CONDUCTORES':
        return { ...state, selectedUser: action.selectedUser }
      case 'ADD_USER_CONDUCTORES':
        return { ...state }
      case 'DELETE_USER_CONDUCTORES':
        return { ...state }
      default:
        return { ...state }
    }
  }
  export default usersConductores
  